import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { Container, Modal, Button } from "react-bootstrap";
const ResendPasswordNotification = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} size="sm" centered onHide={onClose}>
      <Container fluid>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={onClose}
            style={{
              position: "absolute",
              top: 10,
              right: 20,
              cursor: "pointer",
            }}
          >
            <p>X</p>
          </div>
          <p style={{ paddingTop: "5%" }}>{t("resend-password-message")}</p>
        </Modal.Body>
      </Container>
    </Modal>
  );
};

export default ResendPasswordNotification;
